import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWithReauth from '../../../utils/baseQueryWithReauth';

export const sessionApi = createApi({
  reducerPath: 'sessionApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getSessionDuration: builder.query({
      query: () => ({
        url: `/WebSlot/GetAllSlotPricing`,
        method: "Get"
      }),
    }),
    getAvailableSlots: builder.query({
      query: ({TutorId, SlotPricingId, Date}) => ({
        url: `/WebSessionBooking/GetDateSpecificAvailabilityWithSlot`,
        method: "Get",
        params: {TutorId, SlotPricingId, Date}
      }),
    }),
    bookSlotSession: builder.mutation({
      query: (credentials) => ({
        url: `/WebSessionBooking/BookSlotSession`,
        method: "Post",
        body: credentials
      }),
    }),
    getUpcomingSessions: builder.query({
      query: ({pageNumber, pageSize, search, filter, studentId}) => {
        const params = {pageNumber, pageSize};

        if(filter){
          params.filter = filter
        }
        if(studentId){
          params.studentId = studentId
        }
        if(search){
          params.search = search
        }
        return {
        url: `/WebSessionBooking/GetAllUpcomingSessions`,
        method: "Get",
        params
      }},
    }),
    getPastSessions: builder.query({
      query: ({pageNumber, pageSize, search, filter}) => ({
        url: `/WebSessionBooking/GetSlotSessionsHistoryAsync`,
        method: "Get",
        params: {pageNumber, pageSize, search, filter}
      }),
    }),
    getSessionDetails: builder.query({
      query: ({slotSessionId}) => ({
        url: `/WebSessionBooking/GetSlotSessionById`,
        method: "Get",
        params: {slotSessionId}
      }),
    }),
    cancelSession: builder.mutation({
      query: ({SessionBookingId}) => ({
        url: `/WebSessionBooking/CancelSlotSession`,
        method: "Post",
        params: {SessionBookingId}
      }),
    }),
    rescheduleSession: builder.mutation({
      query: (credentials) => ({
        url: `/WebSessionBooking/RescheduleSlotSession`,
        method: "Post",
        body: credentials
      }),
    }),
    getUserDashboard: builder.query({
      query: ({pageNumber, pageSize, search}) => ({
        url: `/WebSessionBooking/GetUserDashboard`,
        method: "Get",
        params: {pageNumber, pageSize, search}
      })
    }),
   getTutorAbsent: builder.query({
    query: ({ SlotSessionId }) => ({
      url: `/WebSessionBooking/MarkTutorAsAbsent`,
      method: "GET",
      params: { SlotSessionId }
    }),
  }),
  assignTutorProficiency: builder.mutation({
    query: ({ bookingId, tutorProficiency }) => ({
      url: "/WebSessionBooking/AssignTutorProficiencyToSession",
      method: "POST",
      params: { bookingId, tutorProficiency },
    }),
  }),
  }),
});

export const {
  useGetSessionDurationQuery,
  useGetAvailableSlotsQuery,
  useBookSlotSessionMutation,
  useGetUpcomingSessionsQuery,
  useLazyGetUpcomingSessionsQuery,
  useGetPastSessionsQuery,
  useLazyGetPastSessionsQuery,
  useGetSessionDetailsQuery,
  useCancelSessionMutation,
  useRescheduleSessionMutation,
  useGetUserDashboardQuery,
  useLazyGetTutorAbsentQuery,
  useAssignTutorProficiencyMutation
} = sessionApi;